"use strict";

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
export const featureWindowVariableName = '__FEATURE_NAME__';
export const getFeatureName = () => {
  if (typeof window !== 'undefined') {
    return window[featureWindowVariableName];
  }
  return 'na';
};
export const setFeatureName = _ref => {
  let {
    featureName,
    mfeAppName
  } = _ref;
  if (typeof window === 'undefined' || window[featureWindowVariableName] || !featureName && !mfeAppName) return;
  window[featureWindowVariableName] = featureName || buildFeatureName(mfeAppName || '');
};
export const buildFeatureName = mfeName => {
  if (mfeName.startsWith('@autoguru/')) {
    mfeName = mfeName.slice(10); // Remove '@autoguru/' from the start
  }
  return mfeName.replace(/(-app-shell$)|-/g, (_, group1) => group1 ? '' : '_').toUpperCase();
};